import React from 'react'
import { CreateTimeClockFlowProvider } from './context/CreateTimeClockFlowProvider'
import { CreateTimeClockFlowMain } from './components/CreateTimeClockFlowMain'

export const CreateTimeClockFlow = () => {
  return (
    <CreateTimeClockFlowProvider>
      <CreateTimeClockFlowMain />
    </CreateTimeClockFlowProvider>
  )
}
